import { AutoComplete, Button, Card, Col, DatePicker, Form, Icon, Input, message, Row, Select, Spin } from 'antd';
import React, { Component } from 'react';
import { sanitizeFieldName } from '../../util/methods';
import moment from 'moment';
import DocumentList from '../../components/DocumentList';
import Table from 'antd/es/table';
import MasterModal from "../../components/MasterModal";
import Descriptions from "antd/lib/descriptions";
import { stringify } from "query-string";
import { findParentAsset, findSubAssets } from '../../appRedux/actions/AssetTransferAdvice';
// import Mileage from '../Fuel/Mileage';

let readings = [], meter = [], meterUnit = [];
const { TextArea } = Input;

class Create extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mainTableDataSource: [],
      assetSearchFilter: [],
      documentData: [],
      meter: [],
      meterUnit: [],
    };
    meter = [];
    meterUnit = [];
    readings = [];
  }

  componentDidMount() {
    const { match, fetch } = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
  }

  componentWillUnmount() {
    readings = [];
    meter = [];
    meterUnit = [];
    this.props.clearProps();
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.data && nextProps.data.assets && nextProps.data.assets.length && (this.props.title === 'EDIT' || this.props.title === 'VIEW')) {
      const assetData = nextProps.data.assets;
      const arr = assetData.map(item => {
        return {
          key: item._id,
          assetCode: item.assetCode,
          rate: item.rate,
          description: item.description,
          remove: item,
          meter: item.meter || 0,
          meterUnit: item.meterUnit,
        }
      });

      for (let i = 0; i < arr.length; i++) {
        let asset = arr[i];
        asset.children = [];
        for (let j = 0; j < nextProps.data.dependentAssets.length; j++) {
          let sAsset = nextProps.data.dependentAssets[j].subAsset;
          if (stringify(asset.key) === stringify(nextProps.data.dependentAssets[j].parentAsset)) {
            asset.children.push({
              key: sAsset._id,
              assetCode: sAsset.assetCode,
              description: sAsset.description || `Dependent Asset of ${asset.assetCode}`,
              remove: sAsset,
              subAsset: true,
            });
          }
        }
      }
      if (meter.length === 0 && meterUnit.length === 0) {
        for (let i = 0; i < arr.length; i++) {
          meterUnit[i] = {};
          meter[i] = {};
          meter[i] = { asset: arr[i].key, meter: arr[i].meter || 0 };
          meterUnit[i] = { meterUnit: arr[i].meterUnit, asset: arr[i].key };
        }
      }
      this.setState({ mainTableDataSource: arr, meter, meterUnit });
    }

    if (nextProps.assetsList !== this.props.assetsList) {
      const arr = nextProps.assetsList.filter((item) => {
        return this.state.mainTableDataSource.findIndex(b => b.assetCode === item.assetCode) < 0;
      });
      this.setState({ assetSearchFilter: arr })
    }
  }

  handleSubmit = (e) => {
    const { match } = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }
      if (this.state.mainTableDataSource.length === 0) {
        this.props.form.setFields({
          assets: {
            value: values.assets,
            errors: [new Error('Please select minimum one asset')]
          }
        })
      } else {
        const { documentData } = this.state;
        const data = Object.assign({}, values);
        if (documentData.length === 0) {
          data.documents = this.props && this.props.data && this.props.data.documents;
        } else {
          data.documents = documentData;
        }
        data.dependentAssets = [];
        for (let k = 0; k < this.state.mainTableDataSource.length; k++) {
          let asset = this.state.mainTableDataSource[k];
          if (asset && asset.children && asset.children.length) {
            for (let l = 0; l < asset.children.length; l++) {
              data.dependentAssets.push({
                parentAsset: asset.key,
                subAsset: asset.children[l].key
              });
            }
          }
        }

        data.assets = this.state.mainTableDataSource.map(item => item.key).join();

        for (let i = 0; i < meter.length; i++) {
          if (!meter[i]) {
            meter[i] = {};
          }
        }

        for (let i = 0; i < meterUnit.length; i++) {
          if (!meterUnit[i]) {
            meterUnit[i] = {};
          }
        }

        readings = [];
        if (this.state.mainTableDataSource && this.state.mainTableDataSource.length && meterUnit && meter && meter.length && meterUnit.length) {
          for (let i = 0; i < this.state.mainTableDataSource.length; i++) {
            let meterFound = meter.find(element => stringify(element.asset) === stringify(this.state.mainTableDataSource[i].key));
            let meterUnitFound = meterUnit.find(element => stringify(element.asset) === stringify(this.state.mainTableDataSource[i].key));
            if (meterFound && meterUnitFound) {
              readings.push({
                asset: this.state.mainTableDataSource[i].key,
                meter: meterFound['meter'] || 0,
                meterUnit: meterUnitFound['meterUnit']
              });
            }
          }
          data.readings = readings;
        } else {
          data.readings = [];
        }
        if (match.params && match.params.id) {
          this.props.onSubmit(data, match.params.id);
        } else {
          this.props.onSubmit(data);
        }
      }
    });
  };

  getDocumentData = (data) => {
    this.setState({ documentData: data });
  };

  pushToAssetTable = async (data) => {
    const { assetsList } = this.props;
    let item = assetsList.find(item => item.assetCode === data);
    if (item && Object.keys(item).length && item.parent) {
      let parent = await findParentAsset(item.parent);
      if (parent && parent.assetCode) {
        message.error(`Asset is Linked to Parent Asset ${parent.assetCode}`);
      } else {
        message.error(`Asset is Linked to Parent Asset`);
      }
    } else {
      const { mainTableDataSource } = this.state;
      let index = mainTableDataSource.findIndex(item => item.assetCode === data);        // already present
      index < 0 && mainTableDataSource.push({
        key: item._id,
        assetCode: item.assetCode,
        rate: item.rate,
        description: item.description,
        remove: item,
        children: [],
      });

      // Add Code for parent selection
      if (index < 0) {
        let subAssets = await findSubAssets(item._id);
        for (let i = 0; i < subAssets.length; i++) {
          let sAsset = subAssets[i];
          let index = mainTableDataSource.findIndex(item => item.assetCode === data);
          mainTableDataSource[index].children.push({
            key: sAsset._id,
            assetCode: sAsset.assetCode,
            rate: sAsset.rate,
            description: sAsset.description || `Dependent Asset of ${item.assetCode}`,
            subAsset: true,
            remove: sAsset,
          });
        }
      }
      this.setState({
        mainTableDataSource: mainTableDataSource
      }, () => {
        this.props.form.setFields({
          assets: {
            errors: []
          }
        })
      });
    }
  }

  popFromAssetTable(data) {
    const { mainTableDataSource } = this.state;
    let index = mainTableDataSource.findIndex(item => item.assetCode === data);
    index >= 0 && mainTableDataSource.splice(index, 1);
    this.setState({ mainTableDataSource });
  }

  fetchMeterUnit = (values) => {
    this.props.fetchMeterUnit(values);
  };

  fetchAssetListByOwner(data) {
    this.props.fetchAssetListByOwner(data);
  };

  fetchAssetListByClient(data) {
    this.props.fetchAssetListByClient(data);
  };

  fetchAssetListByLocation(data) {
    this.setState({ mainTableDataSource: [] });
    this.props.fetchAssetListByLocation(data);
  };

  handleMeter = (e, assetId, index) => {
    if (Number(e.target.value) < 0) {
      return message.error('Meter reading can not be negative!');
    }
    let obj = {};
    meter = this.state.meter;
    obj = { asset: assetId, meter: e.target.value || 0 };
    meter[index] = {};
    Object.assign(meter[index], obj);
    console.log('Meter - ', meter)
    this.setState({ meter: meter });
  }

  handleUnitSelect = (value, assetId, index) => {
    let obj = {};
    meterUnit = this.state.meterUnit;
    obj = { meterUnit: value, asset: assetId };
    meterUnit[index] = {};
    Object.assign(meterUnit[index], obj);
    console.log('Unit - ', meterUnit)
    this.setState({ meterUnit: meterUnit });
  }

  handleMeterReadingChanged = (type, value, index) => {
    console.log('index ', index, type, value)
    if (type === 'meterReading') {
      console.log('meterReading', value)
      if (value && value.length) {
        const readings = [];
        for (let i = 0; i < value.length; i++) {
          readings.push({
            meter: value[i].reading,
            unit: value[i].name,
            asset: this.state.mainTableDataSource[i].key,
            meterMaster: value[i].meter,
          });
        }
        console.log('Readings - ', readings)
        this.setState({ readings });
      }
    }
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { data, loading, filters, subDocumentFilters, title, resource, form, assetsList, startSearch } = this.props;
    const { mainTableDataSource, assetSearchFilter } = this.state;

    const columns = [
      {
        title: 'Asset Code',
        dataIndex: 'assetCode',
        key: 'assetCode',
      },

      // {
      //   title: 'Rate',
      //   dataIndex: 'rate',
      //   key: 'rate',
      // },

      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
        render: (item, record, index) => {
          // console.log('record', record)
          return record && record.description
        }
      },
      {
        title: 'Meter',
        dataIndex: 'meter',
        key: 'meter',
        align: 'center',
        render: (item, record, index) => record && !record.subAsset &&
          <input type={'number'} key={record.key} placeholder={'Meter Value'}
            onChange={(e, ind) => {
              this.handleMeter(e, record.key, index)
            }}
            style={{
              width: '45%',
              height: '37px',
              borderRadius: '7px',
              paddingLeft: '12px',
            }}
            disabled={this.props && this.props.title && this.props.title === 'VIEW'}
            value={this.props && this.props.title && this.props.title === 'EDIT' ? this.state.meter[index].meter :
              this.props.title === 'VIEW' ? (record && record.meter) : (this.state.meter && this.state.meter[index] && this.state.meter[index].meter) || ''} />
      },
      {
        title: 'Meter Unit',
        dataIndex: 'meterUnit',
        key: 'meterUnit',
        align: 'center',
        render: (item, record, index) => record && !record.subAsset &&
          <Select
            value={(this.props && this.props.title && this.props.title === 'VIEW') ? record && record.meterUnit :
              (this.state.meterUnit && this.state.meterUnit[index] && this.state.meterUnit[index].meterUnit) || 'Search Unit'}
            key={record.key}
            style={{ width: '85%', height: '40px', borderColor: 'black !important' }}
            disabled={this.props && this.props.title && this.props.title === 'VIEW'}
            showSearch={true}
            showArrow={false}
            allowClear={false}
            onSearch={this.fetchMeterUnit}
            onSelect={(e, recordId, ind) => {
              this.handleUnitSelect(e, record.key, index)
              console.log('Unit - ', e, record.key, index)
            }}
            mode="single"
          >{
              this.props && this.props.meterUnit && this.props.meterUnit.data && this.props.meterUnit.data.map((item) => {
                return <Select.Option key={item._id} value={item.name}>{item['name']}</Select.Option>
              })
            }
          </Select>,
      },
      // {
      //   title: 'Meter Reading',
      //   dataIndex: 'meterReading',
      //   key: 'meterReading',
      //   align: 'center',
      //   render: (item, record, index) => record &&
      //     <Mileage
      //       key={record.key}
      //       visible={true}
      //       onCancel={null}
      //       // onCreate={this.handelMileageCreate}
      //       // resourceName={resource}
      //       // filters={filters}
      //       form={form}
      //       // mileageData={mileageData}
      //       meterReadings={data && data.readings && data.readings.map(r => ({
      //         ...r,
      //         meter: r.meterMaster || null,
      //         unit: r.meterUnit || null,
      //         reading: r.meter || 0,
      //         name: r.meterUnit && r.meterUnit.name || '',
      //       }))}
      //       // filterData={this.props.filterData}
      //       selectedAsset={record.key}
      //       selectedDate={form.getFieldValue('expectedDateOfDelivery')}
      //       isDateBased={true}
      //       // selectedAssetModel={this.props.assetModel}
      //       // assets={assetData}
      //       // assetFuels={assetFuels}
      //       handleChange={(type, value) => this.handleMeterReadingChanged(type, value, index)}
      //     />
      // },

    ];

    if (title === 'CREATE') {
      columns.push({
        title: 'Remove',
        dataIndex: 'remove',
        key: 'remove',
        align: 'center',
        render: (item, record, index) =>
          record && !record.subAsset &&
          <Button type="danger" size="small" loading={loading} value={item._id} defaultValue={item._id}
            onClick={this.popFromAssetTable.bind(this, item.assetCode)}>
            <Icon type="close" />
          </Button>,
      });
    }

    // rowSelection objects indicates the need for row selection
    const rowSelection = (record) => {
      const url = `/asset/history-report/${record.key}`;
      if (record && record.subAsset) {
        window.open(url);
      }
    };

    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title} ${sanitizeFieldName(resource)}`}>
          <Form onSubmit={this.handleSubmit} layout="vertical">

            {
              (title === 'EDIT' || title === 'VIEW') && <Form.Item key={'ataNo'} label={'ATA Number'}>
                {getFieldDecorator('ataNo', {
                  rules: [{ required: false, message: `ATA Number is required!` }],
                  initialValue: ((data && data.ataNo) || ''),
                })(<Input disabled />)
                }
              </Form.Item>
            }

            <Row gutter={16}>
              <Col span={14}>
                <Form.Item key={'from.location'} label={'From Location'}>
                  {getFieldDecorator('from.location', {
                    rules: [{ required: true, message: `From Location is required!` }],
                    initialValue: data && data.from && data.from.location && data.from.location._id,
                  })(<Select
                    showSearch
                    style={{ width: '80%' }}
                    placeholder="Please select"
                    onSelect={this.fetchAssetListByLocation.bind(this)}
                    backfill={true}
                    filterOption={(input, option) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    disabled={((title === 'EDIT' || title === 'VIEW') && filters['from.location'] && filters['from.location'].options.disabledOnEdit) || false}
                  >
                    {filters['from.location'] && filters['from.location']['data'] && filters['from.location']['data']['data'].map(item => !item.isSystemGenerated &&
                      <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
                  </Select>)}
                  {
                    filters['from.location'] && filters['from.location'].options && filters['from.location'].options.master && this.props.title !== 'VIEW' ?
                      <MasterModal resource={resource} item={filters['from.location'].options.ref}
                        title={'CREATE'} /> : ''
                  }
                </Form.Item>
              </Col>
              <Col span={14}>
                <Form.Item key={'from.client'} label={'From Sub Location'}>
                  {getFieldDecorator('from.client', {
                    rules: [{ required: false, message: `From Sub Location is required!` }],
                    initialValue: data && data.from && data.from.client && data.from.client._id,
                  })(<Select
                    showSearch
                    allowClear
                    style={{ width: '80%' }}
                    onChange={this.fetchAssetListByClient.bind(this)}
                    placeholder="Select From Sub Location"
                    onSelect={this.fetchAssetListByClient.bind(this)}
                    filterOption={(input, option) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    disabled={((title === 'EDIT' || title === 'VIEW') && filters['from.client'] && filters['from.client'].options.disabledOnEdit) || false}
                  >
                    {filters['from.client'] && filters['from.client']['data'] && filters['from.client']['data']['data'].map(item => !item.isSystemGenerated &&
                      <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
                  </Select>)}
                  {
                    filters['from.client'] && filters['from.client'].options && filters['from.client'].options.master && this.props.title !== 'VIEW' ?
                      <MasterModal resource={resource} item={filters['from.client'].options.ref} title={'CREATE'} /> : ''
                  }
                </Form.Item>
              </Col>
              <Col span={14}>
                <Form.Item key={'owner'} label={'Owner'}>
                  {getFieldDecorator('owner', {
                    rules: [{ required: false, message: `Owner is required!` }],
                    initialValue: data && data.owner && data.owner._id
                  })(<Select
                    showSearch
                    style={{ width: '80%' }}
                    placeholder="Please select Owner"
                    onSelect={this.fetchAssetListByOwner.bind(this)}
                    filterOption={(input, option) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    disabled={((title === 'EDIT' || title === 'VIEW') && filters['owner'] && filters['owner'].options.disabledOnEdit) || false}
                  >
                    {filters['owner'] && filters['owner']['data'] && filters['owner']['data']['data'].map(item =>
                      <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
                  </Select>)}
                  {
                    filters['owner'] && filters['owner'].options && filters['owner'].options.master && this.props.title !== 'VIEW' ?
                      <MasterModal resource={resource} item={filters['owner'].options.ref} title={'CREATE'} /> : ''
                  }
                </Form.Item>
              </Col>
              {
                title === 'CREATE' && <Col span={12}>
                  <Form.Item key={'assetSearchQuery'} label={'Search Assets'}>
                    <AutoComplete onSearch={this.props.fetchAssetsByQuery}
                      onSelect={this.pushToAssetTable.bind(this)}
                      placeholder={'ex. abc'}
                      disabled={(title === 'EDIT' || title === 'VIEW') || !startSearch}>
                      {
                        assetSearchFilter.map((item) => {
                          return <Select.Option key={item._id} value={item.assetCode}>{item.assetCode}</Select.Option>
                        })
                      }
                    </AutoComplete>
                  </Form.Item>
                </Col>
              }
            </Row>

            <Form.Item key={'assets'} label={'Assets'}>
              {getFieldDecorator('assets', {
                rules: [{ required: false, message: `Assets is required!` }],
                initialValue: (data && data.assets && data.assets.length) ? data.assets.map(field => field._id) : [],
              })(<Table columns={columns} dataSource={mainTableDataSource} pagination={false}
                onRowClick={rowSelection} />)
              }
            </Form.Item>

            <Descriptions bordered title="">
              <Descriptions.Item
                label="Asset Count"> {title === 'CREATE' ? (mainTableDataSource.length || 0) : (data && data.assets && data.assets.length) ?
                  data.assets.length : 0}</Descriptions.Item>
            </Descriptions>

            <Row gutter={16}>
              <Col span={14}>
                <Form.Item key={'to.location'} label={'To Location'} style={{ marginTop: '15px' }}>
                  {getFieldDecorator('to.location', {
                    rules: [{ required: true, message: `To Location is required!` }],
                    initialValue: data && data.to && data.to.location && data.to.location._id,
                  })(<Select
                    showSearch
                    style={{ width: '80%' }}
                    placeholder="Please select"
                    filterOption={(input, option) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    disabled={((title === 'EDIT' || title === 'VIEW') && filters['to.location'] && filters['to.location'].options.disabledOnEdit) || false}
                  >
                    {filters['to.location'] && filters['to.location']['data'] && filters['to.location']['data']['data'].map(item => !item.isSystemGenerated &&
                      <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
                  </Select>)}
                  {
                    filters['to.location'] && filters['to.location'].options && filters['to.location'].options.master && this.props.title !== 'VIEW' ?
                      <MasterModal resource={resource} item={filters['to.location'].options.ref} title={'CREATE'} /> : ''
                  }
                </Form.Item>
              </Col>
              <Col span={14}>
                <Form.Item key={'to.client'} label={'To Sub Location'}>
                  {getFieldDecorator('to.client', {
                    rules: [{ required: false, message: `To Sub Location is required!` }],
                    initialValue: data && data.to && data.to.client && data.to.client._id,
                  })(<Select
                    showSearch
                    allowClear
                    style={{ width: '80%' }}
                    placeholder="Select To Sub Location"
                    filterOption={(input, option) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    disabled={((title === 'EDIT' || title === 'VIEW') && filters['to.client'] && filters['to.client'].options.disabledOnEdit) || false}
                  >
                    {filters['to.client'] && filters['to.client']['data'] && filters['to.client']['data']['data'].map(item =>
                      <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
                  </Select>)}
                  {
                    filters['to.client'] && filters['to.client'].options && filters['to.client'].options.master && this.props.title !== 'VIEW' ?
                      <MasterModal resource={resource} item={filters['to.client'].options.ref} title={'CREATE'} /> : ''
                  }
                </Form.Item>
              </Col>
            </Row>

            <Form.Item key={'modeOfTransport'} label={'Mode Of Transport'}>
              {getFieldDecorator('modeOfTransport', {
                rules: [{ required: true, message: `Mode Of Transport is required!` }],
                initialValue: data && data.modeOfTransport,
              })(<Select
                placeholder={`Please select Mode Of Transport`}
                disabled={((title === 'EDIT' || title === 'VIEW') && filters['modeOfTransport'] && filters['modeOfTransport'].options.disabledOnEdit) || false}
              >
                {filters['modeOfTransport'] && filters['modeOfTransport'].options && filters['modeOfTransport'].options.enum && filters['modeOfTransport'].options.enum.map(item =>
                  <Select.Option key={item}
                    value={item}>{item}</Select.Option>)}
              </Select>)
              }
            </Form.Item>

            <Form.Item key={'transportationCost'} label={'Transportation Cost'}>
              {getFieldDecorator('transportationCost', {
                rules: [{ required: true, message: `Transport Details is required!` }],
                initialValue: data && data.transportationCost,
              })(<Input type='number'
                onWheel={event => event.currentTarget.blur()}
                placeholder={'Transportation Cost'}
                style={{ marginRight: 8 }}
                disabled={(title === 'VIEW' && filters['transportationCost'] && filters['transportationCost'].options.disabledOnEdit) || false} />)
              }
            </Form.Item>

            <Form.Item key={'transporter'} label={'Transporter'}>
              {getFieldDecorator('transporter', {
                rules: [{ required: true, message: `Transporter is required!` }],
                initialValue: data && data.transporter && data.transporter._id,
              })(<Select
                showSearch
                style={{ width: '80%' }}
                placeholder="Please select transporter"
                filterOption={(input, option) =>
                  (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                }
                disabled={(title === 'VIEW' && filters['transporter'] && filters['transporter'].options.disabledOnEdit) || false}
              >
                {filters['transporter'] && filters['transporter']['data'] && filters['transporter']['data']['data'].map(item =>
                  <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
              </Select>)}
              {
                filters['transporter'] && filters['transporter'].options && filters['transporter'].options.master ?
                  <MasterModal resource={resource} item={filters['transporter'].options.ref} title={'CREATE'} /> : ''
              }
            </Form.Item>

            <Form.Item key={'transportDetails'} label={'Transport Details'}>
              {getFieldDecorator('transportDetails', {
                rules: [{ required: true, message: `Transport Details is required!` }],
                initialValue: data && data.transportDetails,
              })(<Input placeholder={'Transport Details'}
                disabled={((title === 'EDIT' || title === 'VIEW') && filters['transportDetails'] && filters['transportDetails'].options.disabledOnEdit) || false} />)
              }
            </Form.Item>

            <Form.Item key={'otherCost'} label={'Other Cost'}>
              {getFieldDecorator('otherCost', {
                rules: [{ required: false, message: `Other Cost is required!` }],
                initialValue: data && data.otherCost,
              })(<Input type='number'
                onWheel={event => event.currentTarget.blur()}
                placeholder={'Other Cost'}
                style={{ marginRight: 8 }}
                disabled={(title === 'VIEW' && filters['otherCost'] && filters['otherCost'].options.disabledOnEdit) || false} />)
              }
            </Form.Item>
            <Form.Item key={'otherCostDetails'} label={'Other Cost Details'}>
              {getFieldDecorator('otherCostDetails', {
                rules: [{ required: false, message: `Other Cost Details is required!` }],
                initialValue: data && data.otherCostDetails,
              })(<Input placeholder={'Other Cost Details'}
                disabled={((title === 'EDIT' || title === 'VIEW') && filters['otherCostDetails'] && filters['otherCostDetails'].options.disabledOnEdit) || false} />)
              }
            </Form.Item>

            <Form.Item key={'dispatchDate'} label={'Dispatch Date'}>
              {getFieldDecorator('dispatchDate', {
                rules: [{ required: true, message: `Dispatch Date is required!` }],
                initialValue: data && data.dispatchDate && moment(data.dispatchDate),
              })(<DatePicker showTime
                disabled={((title === 'EDIT' || title === 'VIEW') && filters['dispatchDate'] && filters['dispatchDate'].options.disabledOnEdit) || false} />)
              }
            </Form.Item>

            <Form.Item key={'expectedDateOfDelivery'} label={'Expected Date Of Delivery'}>
              {getFieldDecorator('expectedDateOfDelivery', {
                rules: [{ required: true, message: `Expected Date Of Delivery is required!` }],
                initialValue: data && data.expectedDateOfDelivery && moment(data.expectedDateOfDelivery),
              })(<DatePicker showTime
                disabled={((title === 'EDIT' || title === 'VIEW') && filters['expectedDateOfDelivery'] && filters['expectedDateOfDelivery'].options.disabledOnEdit) || false} />)
              }
            </Form.Item>

            <Form.Item key={'consignedBy'} label={'Consigned By'}>
              {getFieldDecorator('consignedBy', {
                rules: [{ required: true, message: `Consigned By is required!` }],
                initialValue: data && data.consignedBy && data.consignedBy._id,
              })(<Select
                showSearch
                style={{ width: '80%' }}
                placeholder="Please select"
                filterOption={(input, option) =>
                  (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                }
                disabled={((title === 'EDIT' || title === 'VIEW') && filters['consignedBy'] && filters['consignedBy'].options.disabledOnEdit) || false}
              >
                {filters['consignedBy'] && filters['consignedBy']['data'] && filters['consignedBy']['data']['data'].map(item =>
                  <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
              </Select>)}
              {
                filters['consignedBy'] && filters['consignedBy'].options && filters['consignedBy'].options.master && this.props.title !== 'VIEW' ?
                  <MasterModal resource={resource} item={filters['consignedBy'].options.ref} title={'CREATE'} /> : ''
              }
            </Form.Item>

            <Form.Item key={'consignedTo'} label={'Consigned To'}>
              {getFieldDecorator('consignedTo', {
                rules: [{ required: true, message: `Consigned To is required!` }],
                initialValue: data && data.consignedTo && data.consignedTo._id,
              })(<Select
                showSearch
                style={{ width: '80%' }}
                placeholder="Please select"
                filterOption={(input, option) =>
                  (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                }
                disabled={((title === 'EDIT' || title === 'VIEW') && filters['consignedTo'] && filters['consignedTo'].options.disabledOnEdit) || false}
              >
                {filters['consignedTo'] && filters['consignedTo']['data'] && filters['consignedTo']['data']['data'].map(item =>
                  <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
              </Select>)}
              {
                filters['consignedTo'] && filters['consignedTo'].options && filters['consignedTo'].options.master && this.props.title !== 'VIEW' ?
                  <MasterModal resource={resource} item={filters['consignedTo'].options.ref} title={'CREATE'} /> : ''
              }
            </Form.Item>

            <Row gutter={16}>
              <Col span={14}>
                <Form.Item key={'preparedBy.name'} label={'Prepared By Name'}>
                  {getFieldDecorator('preparedBy.name', {
                    rules: [{ required: true, message: `Prepared By Name is required!` }],
                    initialValue: data && data.preparedBy && data.preparedBy.name && data.preparedBy.name._id,
                  })(<Select
                    showSearch
                    style={{ width: '80%' }}
                    placeholder="Please select"
                    filterOption={(input, option) =>
                      (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                    }
                    disabled={((title === 'EDIT' || title === 'VIEW') && filters['preparedBy.name'] && filters['preparedBy.name'].options.disabledOnEdit) || false}
                  >
                    {filters['preparedBy.name'] && filters['preparedBy.name']['data'] && filters['preparedBy.name']['data']['data'].map(item =>
                      <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
                  </Select>)}
                  {
                    filters['preparedBy.name'] && filters['preparedBy.name'].options && filters['preparedBy.name'].options.master && this.props.title !== 'VIEW' ?
                      <MasterModal resource={resource} item={filters['preparedBy.name'].options.ref}
                        title={'CREATE'} /> : ''
                  }
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item key={'preparedBy.date'} label={'Prepared By Date'}>
                  {getFieldDecorator('preparedBy.date', {
                    rules: [{ required: true, message: `Prepared By Date is required!` }],
                    initialValue: data && data.preparedBy && data.preparedBy.date && moment(data.preparedBy.date),
                  })(<DatePicker
                    disabled={((title === 'EDIT' || title === 'VIEW') && filters['preparedBy.date'] && filters['preparedBy.date'].options.disabledOnEdit) || false} />)}
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={14}>
                <Form.Item key={'approvedBy.name'} label={'Approved By Name'}>
                  {getFieldDecorator('approvedBy.name', {
                    rules: [{ required: true, message: `Approved By Name is required!` }],
                    initialValue: data && data.approvedBy && data.approvedBy.name && data.approvedBy.name._id,
                  })(<Select
                    showSearch
                    style={{ width: '80%' }}
                    placeholder="Please select"
                    filterOption={(input, option) =>
                      (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                    }
                    disabled={((title === 'EDIT' || title === 'VIEW') && filters['approvedBy.name'] && filters['approvedBy.name'].options.disabledOnEdit) || false}
                  >
                    {filters['approvedBy.name'] && filters['approvedBy.name']['data'] && filters['approvedBy.name']['data']['data'].map(item =>
                      <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
                  </Select>)}
                  {
                    filters['approvedBy.name'] && filters['approvedBy.name'].options && filters['approvedBy.name'].options.master && this.props.title !== 'VIEW' ?
                      <MasterModal resource={resource} item={filters['approvedBy.name'].options.ref}
                        title={'CREATE'} /> : ''
                  }
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item key={'approvedBy.date'} label={'Approved By Date'}>
                  {getFieldDecorator('approvedBy.date', {
                    rules: [{ required: true, message: `Approved By Date is required!` }],
                    initialValue: data && data.approvedBy && data.approvedBy.date && moment(data.approvedBy.date),
                  })(<DatePicker
                    disabled={((title === 'EDIT' || title === 'VIEW') && filters['approvedBy.date'] && filters['approvedBy.date'].options.disabledOnEdit) || false} />)}
                </Form.Item>
              </Col>
            </Row>

            <Form.Item key={'remarks'} label={'Remarks'}>
              {getFieldDecorator('remarks', { initialValue: data && data.remarks })(<TextArea disabled={title === 'VIEW'}
                rows={3} />)}
            </Form.Item>

            {
              filters && filters.documents &&
              <DocumentList history={this.props.history} match={this.props.match} key={filters.documents}
                item={filters.documents} form={form} data={data.documents} title={this.props.title}
                subDocumentFilters={subDocumentFilters} getDocumentData={this.getDocumentData}
                isDisabled={((this.props.title === 'VIEW') ? true : filters['documents'] && filters['documents'].options.disabledOnEdit) || false} />
            }

            <Form.Item>
              {this.props.title === 'VIEW' ? '' :
                <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}
                  disabled={this.props.title === 'VIEW' || false}>
                  {this.props.title === 'EDIT' ? 'UPDATE' : 'CREATE'}
                </Button>}
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
